import axios from 'axios';
import store from '../../store/index';

export default {
	list(showDeleted) {
		return axios.get(`/api/users?deleted=${showDeleted}&sort=lastName`);
	},
	allAbsences(id) {
		if (id) {
			return axios.get(`/api/absences?user=${id}`);
		}
		return axios.get(`/api/absences`);
	},
	absenceOverlap(absence) {
		return axios.post('/api/absences/validate-overlap', absence);
	},
	allPreferences() {
		return axios.get(`/api/preferences`);
	},
	listSupervisors() {
		return axios.get(`/api/users/supervisors`);
	},
	listDrivers() {
		return axios.get(`/api/users/drivers`);
	},
	getStatistics(user, date) {
		return axios.post('/api/statistics', {
			users: [user],
			from: date,
			to: date,
		});
	},
	getLastStatistics(user, year) {
		return axios.post('/api/statistics/last', {
			user,
			year,
		});
	},
	getPublishedMetRatio(user) {
		return axios.get('/api/statistics/met/' + user);
	},
	getOnlineUsers() {
		return axios.get('/api/users/online');
	},
	getManualWorktimeBalances(user, month = '') {
		const url = `/api/manualbalance/workTime/${user}?month=${month}`;
		return axios.get(url);
	},
	getSingleUserManualWorktimeBalances(user, month = '') {
		const url = `/api/manualbalance/user/${user}?month=${month}`;
		return axios.get(url);
	},
	createWorktimeBalances(balance) {
		return axios.post('/api/manualbalance', balance);
	},
	updateWorktimeBalance(balance) {
		return axios.patch(`/api/manualbalance/${balance.id}`, balance);
	},
	deleteWorktimeBalance({ id, changeComment }) {
		return axios.delete(`/api/manualbalance/${id}`, {
			data: { changeComment },
		});
	},
};
